// Native
import { useEffect, useState } from "react"
import { Spinner } from "@chakra-ui/react"

// Custom
import { API } from "config"
import { Parts, UI } from "components"
import useUser from "hooks/useUser"
import Register from "./register"

export default function Adhesion(){

    const user = useUser()
    const [ loading, setLoading ] = useState(false)
    const [ adhesion, setAdhesion ] = useState()

    const load = async () => {
        setLoading(true)

        try{
            const callback = await API.get('/adhesion')
            setAdhesion(callback.data)
        }catch(err){
            setAdhesion(null)
        }

        setLoading(false)
    }

    useEffect(() => {
        load()
    }, [])

    return(
    <>
    <Parts.Dialog.Profile.Address open={!user.data?.address?.line_1} />
    <UI.Header hiddenAlerts title={`Falta pouco, ${user.data?.name?.split(' ')[0]}!`} mb={4} />

    <UI.Show visible={loading}><UI.Alert indicator={<Spinner />}>Verificando adesão...</UI.Alert></UI.Show>
    <UI.Show visible={!loading && !!adhesion}><Parts.Screens.Order data={adhesion} /></UI.Show>
    <UI.Show visible={!loading && !adhesion}><Register /></UI.Show>
    </>
    )
}